import CropImg from '@/components/CropImg/CropImg.vue';
import ChannelSessionManager from '@/Manager/Session/Channels.manager';
import Global from "@/scripts/Global";
import VueSignals from '@/scripts/VueSignals';
import ChannelApi from '@/scripts/api/channel.api'
export default {
    name: 'UploadChannelPicture',
    components: {
        CropImg
    },
    data() {
        return {
            data: null,
            url: '',
            type: '',
            loading: false,
            errorMessage: ''
        }
    },
    mounted() {
        this.data = this.$parent.data;
        this.url = this.data.url;
        this.type = this.data.type;
    },
    methods: {
        getCroppedResult(data) {
            this.loading = true;

            let canvas = data.canvas;
            let quality = 1;
            let url = canvas.toDataURL(this.type, quality);
            let size = url.split(',')[1].length;
            let tries = 0;
            // Api just accept images max 100000 bytes
            while (size > 100000 && tries < 100) {
                // quality -= 0.1;
                // slower but get better resolution, think a better algorithm
                quality *= 0.9;
                // Only image/jpeg and image/web are affected by quality parameter
                url = canvas.toDataURL('image/jpeg', quality);
                size = url.split(',')[1].length;
                tries++;
            }

            //Logic to upload the channel picture
            let separate = url.split(';');
            let image_doc = {
                mimetype: separate[0].replace('data:', ''),
                valueb64: separate[1].split(',')[1]
            };
            ChannelApi.editChannelAttributes(ChannelSessionManager.GetActiveChannelId(), {image_doc: image_doc})
            .then(res => {
                this.loading = false;
                if (!res) {
                    this.loading = false;
                    this.errorMessage = 'System error, please try later';
                    setTimeout(_ => this.errorMessage = '', 10000);
                }
                if (res.data.result) {
                    this.errorMessage = '';
                    ChannelSessionManager.updateCurrentChannelPicture(url);
                    Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false);
                    Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'channel_settings')
                } else {
                    // Message error, mostly files too large
                    let errorMessage = res.data.reason;
                    if (errorMessage == 'image_too_large') {
                        this.errorMessage = 'Image too large';
                    } else {
                        this.errorMessage = errorMessage;
                    }
                    setTimeout(_ => this.errorMessage = '', 10000);
                }
            }, err => {
                this.loading = false;
                this.errorMessage = 'System error, please try later';
                setTimeout(_ => this.errorMessage = '', 10000);
                console.error(err);
            });
        }
    }
}
